import React, { Component } from 'react'
import axios from 'axios'
import { Redirect } from 'react-router-dom'
import { authenticatedUserStore } from 'src/stores'

export default function withAuth(ComponentToProtect) {
    return class extends Component {
        constructor(props, context) {
            super(props, context)
            this.state = {
                loading: true,
                authorized: true,
            }
        }

        componentDidMount() {
            if (authenticatedUserStore.authToken) {
                if (this.state.loading) {
                    this.setState({ loading: false })
                }
                return
            }

            axios
                .get('/sso-login')
                .then(async res => {
                    const { token } = res.data
                    if (!token) {
                        window.location.href = '/sso-login'
                        return
                    }

                    if (
                        res.data.permissions &&
                        res.data.permissions.length !== 0
                    ) {
                        authenticatedUserStore.setPermissions(
                            res.data.permissions
                        )
                    } else {
                        this.setState({ loading: false, authorized: false })
                        return
                    }

                    authenticatedUserStore.setAuthToken(res.data.token)
                    if (res.data.user) {
                        const {
                            firstName,
                            lastName,
                            email,
                            username,
                            is_global_admin,
                            is_local_user,
                            organization_id,
                        } = res.data.user
                        authenticatedUserStore.setUserData({
                            firstName,
                            lastName,
                            email,
                            username,
                            is_global_admin,
                            is_local_user,
                            organization_id,
                        })
                        await authenticatedUserStore.loadUserOrganizations()
                        if (
                            !is_global_admin &&
                            authenticatedUserStore.userOrganizations.length ===
                                0
                        ) {
                            this.setState({
                                loading: false,
                                authorized: false,
                            })
                        } else {
                            this.setState({ loading: false })
                        }
                    }
                })
                .catch(_ => {
                    this.setState({ loading: false, authorized: false })
                })
        }
        render() {
            const { loading, authorized } = this.state
            if (loading) {
                return null
            }
            if (!authorized) {
                return <Redirect to={'/unauthorized'} />
            }
            return <ComponentToProtect {...this.props} />
        }
    }
}
